import React from "react";
import { KeyboardAvoidingView, ScrollView, View } from "react-native";

import GestureRecognizer, {
  swipeDirections,
} from "react-native-swipe-gestures";

import appPages from "../../../../appPages";
import appStyles from "../../../appStyles";
import { isAndroid, navigate } from "../../../../helpers/utils";

import PageTerms from "../../../terms";

import CarouselSlide from "./CarouselSlide";
import CarouselProgressBar from "../progressBar/CarouselProgressBar";

import SCREENS from "./slides";
import ProgressBarConfig from "../progressBar/config";
import ManaButton from "../../common/ManaButton";
import SettingsHelper from "../../more/SettingsHelper";
import SetupConfig from "../../home/cards/onboarding/SetupConfig";

export default class OnboardingInfoPage extends React.Component {
  constructor(props) {
    super(props);
    this.controller = props.controller;

    const settings = this.controller.state.settings || {};

    this.state = {
      currentSlideIndex: 0,
      slides: SCREENS,
      name: settings.nickname || "",
      country: settings.country || "",
    };
  }

  changeScreen = (offset) => {
    const { currentSlideIndex, slides, name, country } = this.state;
    const next = currentSlideIndex + offset;

    // Back
    if (next == -1) {
      navigate(this.controller, appPages.onboardingPage);
    }

    // All info checked: save and redirect
    if (next >= slides.length) {
      if (name && country) {
        this.controller.apiService
          .cardAction({
            action: "save",
            target: appPages.onboardingInfoPage,
            nickname: name,
            country: country,
            requestPage: appPages.homePage,
            requestArgs: {},
          })
          .then(() => {
            // Save current step in settings for checklist display
            SettingsHelper.updateSetupProgress(this.controller, {
              [SetupConfig.profile.name]: true,
            });

            this.controller.navigate(appPages.integrationsOnboarding);
          });
      } else {
        this.setState((state) => ({
          ...state,
          currentSlideIndex: !name ? 0 : 1,
        }));
      }
      // To to next slider
    } else {
      this.setState((state) => ({
        ...state,
        currentSlideIndex: Math.max(0, next),
      }));
    }
  };

  updateInfo = (key, value) => {
    this.setState((state) => ({ ...state, [key]: value }));
  };

  onSwipe = (direction) => {
    if (direction == swipeDirections.SWIPE_LEFT) {
      this.changeScreen(1);
    }
  };

  getCurrentScreen(onboardingScreen) {
    const { slides } = this.state;

    return slides[
      onboardingScreen >= slides.length ? slides.length - 1 : onboardingScreen
    ];
  }

  render() {
    if (!this.state.slides) return null;
    const { currentSlideIndex } = this.state;

    const showTerms = !this.controller.state?.settings?.terms_agreed;
    const currentSlide = this.getCurrentScreen(currentSlideIndex);
    const numberOfScreens = Object.keys(ProgressBarConfig).length;

    const TAG = currentSlide.name == "name" ? KeyboardAvoidingView : View;

    return (
      <>
        {showTerms ? (
          <PageTerms
            country={this.state.country}
            controller={this.controller}
          />
        ) : (
          <GestureRecognizer
            onSwipe={this.onSwipe}
            style={[appStyles.container, isAndroid ? { paddingTop: 6 } : {}]}
          >
            <TAG
              style={{ flex: 1 }}
              behavior="position"
              keyboardVerticalOffset={-120}
            >
              <CarouselProgressBar
                currentScreenIndex={currentSlideIndex}
                numberOfScreens={numberOfScreens}
                changeScreen={this.changeScreen}
                hideNext
              />

              <ScrollView
                style={appStyles.scrollView}
                contentContainerStyle={appStyles.scrollViewContent}
              >
                <CarouselSlide
                  slide={currentSlide}
                  position={currentSlideIndex}
                  changeScreen={this.changeScreen}
                  updateInfo={this.updateInfo}
                  data={this.state}
                />
              </ScrollView>
            </TAG>

            {/* Footer Buttons */}
            <View style={appStyles.footerButtons}>
              <ManaButton
                isMainButton
                disabled={
                  currentSlide.name.indexOf("checklist") < 0 &&
                  !this.state[currentSlide.name]
                }
                text={"Continue"}
                style={appStyles.bottomButton}
                styleText={appStyles.bottomButtonText}
                onPress={() => this.changeScreen(1)}
              />
            </View>
          </GestureRecognizer>
        )}
      </>
    );
  }
}
